import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xie2",
  "use": "icon-xie2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xie2\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 3H13V5V9H11V5H7V3H11ZM7 7H9V9H7V7ZM5 11V9H7V11H5ZM5 11V13H3V11H5Z\" fill=\"#19E3FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol